module.exports = __webpack_public_path__ + "static/img/119.c7a4370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/119.png
// module id = wubt
// module chunks = 0